import React from 'react';
import {
    Actions,
    Components,
    Features,
    getHeapDataAttribute,
    Teams,
} from '../../../utils/heap-data';
import { LogoInterface } from '../utils/interfaces';
import './Logo.scss';

const Logo = ({ title }: LogoInterface) => {
    return (
        <section
            data-heap-id={getHeapDataAttribute({
                team: Teams.SEO,
                feature: Features.OrganizerSubNav,
                component: Components.Logo,
                name: 'logo',
                action: Actions.Click,
            })}
            className="organizer-logo"
        >
            <span className="organizer-logo__logo">{title}</span>
        </section>
    );
};

export default Logo;
